import { defineComponent as _defineComponent } from 'vue'
import InlineSvg from 'vue-inline-svg';
import {GenderEnum} from "@/views/pages/support/support-review";


export default /*#__PURE__*/_defineComponent({
  __name: 'SupportAvatar',
  props: {
  user: {
    type: Number,
    default: 1
  },
  gender: {
    type: String,
    default: GenderEnum.Male
  }
},
  setup(__props) {

const props = __props;




return { __sfc: true,props, InlineSvg, GenderEnum }
}

})